import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { compact } from 'lodash';
import { Divider } from '@material-ui/core';
import { colors } from '../../../constants/styleConstants';
import { TP } from '../../../constants/consts';

import EditCardButtons from '../EditCardButtons';
import CardBox from '../../CardBox';
import { getOption } from '../../../utils/common';
import ReviewProductionBlock from '../../ReviewsCard/ReviewProductionBlock';
import OuterLink from '../../OuterLink';
import Title from '../../Title';

const useStyles = makeStyles(theme => ({
  artistsReviewCard: {
    padding: theme.spacing(2),
    fontSize: 13,
  },
  cardContent: {
    boxSizing: 'border-box',
    width: '100%',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  unwrap: {
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      marginBottom: theme.spacing(1),
    },
  },
  title: {
    fontSize: 15,
    fontWeight: 'bold',
    color: colors.blackMineShaft,
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    opacity: 0.7,
    marginBottom: theme.spacing(1),
  },
  text: {
    wordBreak: 'break-word',
  },
}));

export const ArtistReviewCard = ({
  className,
  review,
  privacyOptions,
  editButtonName,
  onAddDetails,
  onSelect,
  onDelete,
}) => {
  const classes = useStyles();

  const title = review?.title;
  const description = review?.content;
  const publisher = compact([review?.signature, review.mediaName]).join(' | ');
  const reviewUrl = review?.reviewUrl;

  return (
    <CardBox className={cn(classes.artistsReviewCard, className)}>
      <div className={classes.cardContent}>
        <EditCardButtons
          editClick={onAddDetails}
          visibilityClick={onSelect}
          privacyOptions={privacyOptions}
          editButtonName={editButtonName}
          value={review?.privacyAttribute?.id && getOption(review?.privacyAttribute)}
          className={classes.unwrap}
          onDelete={onDelete}
        />
        <div className={classes.description}>
          {reviewUrl ? <OuterLink href={reviewUrl}>{title}</OuterLink> : <Title>{title}</Title>}
          <div className={classes.subtitle}>{publisher}</div>
          <div className={classes.text}>{description}</div>
        </div>
      </div>
      <Divider />
      <ReviewProductionBlock review={review} isEditMode />
    </CardBox>
  );
};

ArtistReviewCard.propTypes = {
  review: PropTypes.object,
  privacyOptions: PropTypes.array,
  editButtonName: PropTypes.string,
  onAddDetails: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

ArtistReviewCard.defaultProps = {
  editButtonName: `${TP}.FN_ADD_DETAILS`,
};

export default memo(ArtistReviewCard);
